<template>
  <div />
</template>

<script>
export default {
  props: [],
  mounted() {
    this.$nextTick(function () {
      // this.$store.commit('setCurrentPath', '');
    })
  },
  methods: {
  },
}
</script>
